module.exports = __webpack_public_path__ + "img/1F92E.4d3c6e2b.svg";